<div class="icon-wrapper">
  <i (click)="openStatusModal()" class="exclamation triangle icon" [ngClass]="iconColor" title="Dataset status"></i>
</div>
